<ng-http-loader [backdrop]="false" [filteredHeaders]="['ignore_http_loader']" [entryComponent]="progressBar"> </ng-http-loader>
<router-outlet />
<p-toast position="top-center"></p-toast>

<!-- Snackbar toaster -->
<p-toast key="snackbar" position="bottom-center" [preventOpenDuplicates]="true">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="snackbar">
      <span class="message">{{ message.detail | translate }}</span>
      @if (message.data.btns) {
        @for (btn of message.data.btns; track $index) {
          <button [class]="[btn.class, 'btn']" (click)="btn.onClick(closeFn.bind(undefined, $event))">{{ btn.text | translate }}</button>
        }
      }
      <button class="btn" (click)="closeFn($event)">✖</button>
    </div>
  </ng-template>
</p-toast>
